import { useState, useMemo, useCallback } from 'react';
import { produce } from 'immer';
import useReducer from '~/theseus/hooks/useReducer';
import reducer, { produceInitState } from './reducer';

export default function useScheduleSelector(callback) {
  const [selectState, setSelectState] = useState({
    mouseDown: false,
    adding: false,
    removing: false,
  });
  const [state, dispatch] = useReducer(reducer, null, 'ScheduleReducer', produceInitState);

  const endSelecting = useCallback(() => {
    if (selectState.mouseDown) {
      setSelectState({ selecting: false, removing: false, mouseDown: false });
      callback(state.schedule);
    }
  }, [callback, state.schedule, selectState.mouseDown]);

  const clearSchedule = useCallback(() => dispatch({ type: 'reset' }), []);

  const add = useCallback((day, hour) => {
    if (day !== undefined) {
      dispatch({ type: 'addHour', payload: { day, hour } });
    } else {
      dispatch({ type: 'addHourEveryday', payload: { hour } });
    }
  }, []);

  const remove = useCallback((day, hour) => {
    if (day !== undefined) {
      dispatch({ type: 'removeHour', payload: { day, hour } });
    } else {
      dispatch({ type: 'removeHourEveryday', payload: { hour } });
    }
  }, []);

  const isEmpty = useMemo(() => state.totalSelected === 0, [state.totalSelected]);

  const handleHourMouseOver = useCallback((day, hour) => {
    if (selectState.adding) {
      add(day, hour);
    } else {
      remove(day, hour);
    }
  }, [add, remove, selectState.adding]);

  const beginAdding = useCallback((day, hour) => {
    setSelectState(s => produce(s, (draft) => {
      draft.adding = true;
      draft.mouseDown = true;
    }));
    add(day, hour);
  }, [add]);

  const beginRemoving = useCallback((day, hour) => {
    setSelectState(s => produce(s, (draft) => {
      draft.removing = true;
      draft.mouseDown = true;
    }));
    remove(day, hour);
  }, [remove]);

  return {
    schedule: state.schedule,
    everyday: state.everyday,
    isEmpty,
    handleHourMouseOver,
    beginAdding,
    beginRemoving,
    endSelecting,
    mouseDown: selectState.mouseDown,
    clearSchedule,
  };
}
